import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id FA880DCB-AC6F-4C9C-9B6D-6E8236272C31
 * name arrow-left-thick
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowLeftThickIcon = createSvgIcon(<><path d="M20,10V14H11L14.5,17.5L12.08,19.92L4.16,12L12.08,4.08L14.5,6.5L11,10H20Z" /></>, 'ArrowLeftThickIcon');
export default ArrowLeftThickIcon